/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_other_subjects_website_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Mám problém na webu`
};

const da_contact_other_subjects_website_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Jeg oplever et problem på siden`
};

const de_contact_other_subjects_website_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Ich habe ein Problem mit der Website`
};

const en_contact_other_subjects_website_issue = /** @type {(inputs: {}) => string} */ () => {
	return `I encountered an issue on the website`
};

const es_contact_other_subjects_website_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Tengo un problema en el sitio web`
};

const fr_contact_other_subjects_website_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Je rencontre un problème sur le site`
};

const hu_contact_other_subjects_website_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Problémám van az oldalon`
};

const it_contact_other_subjects_website_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Ho un problema sul sito`
};

const nl_contact_other_subjects_website_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Ik heb een probleem met de website`
};

const pl_contact_other_subjects_website_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Mam problem ze stroną`
};

const pt_contact_other_subjects_website_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Estou com um problema no site`
};

const sv_contact_other_subjects_website_issue = /** @type {(inputs: {}) => string} */ () => {
	return `Jag har problem med webbplatsen`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_other_subjects_website_issue = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_other_subjects_website_issue(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_other_subjects_website_issue", locale)
	if (locale === "cs") return cs_contact_other_subjects_website_issue(inputs)
	if (locale === "da") return da_contact_other_subjects_website_issue(inputs)
	if (locale === "de") return de_contact_other_subjects_website_issue(inputs)
	if (locale === "en") return en_contact_other_subjects_website_issue(inputs)
	if (locale === "es") return es_contact_other_subjects_website_issue(inputs)
	if (locale === "fr") return fr_contact_other_subjects_website_issue(inputs)
	if (locale === "hu") return hu_contact_other_subjects_website_issue(inputs)
	if (locale === "it") return it_contact_other_subjects_website_issue(inputs)
	if (locale === "nl") return nl_contact_other_subjects_website_issue(inputs)
	if (locale === "pl") return pl_contact_other_subjects_website_issue(inputs)
	if (locale === "pt") return pt_contact_other_subjects_website_issue(inputs)
	return sv_contact_other_subjects_website_issue(inputs)
};
export { contact_other_subjects_website_issue as "contact.other_subjects.website_issue" }